import { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";

import Stepper from "../../ui/Stepper";

import "../../components/Element/Element.css";
import "./Extras.css";

import { Curso } from "../../components/Curso/Curso";
import InfoExtras from "../../components/InfoExtras";
import { dataActions } from "../../store/data-slice";
import { screenActions } from "../../store/screens-slice";
import { stepperActions } from "../../store/stepper-slice";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { containerVariants } from "../../animations/transitions";
import { isFormCompleted } from "../../helpers/formHelpers";

const Extras = () => {
  const [t] = useTranslation("global");
  const dispatch = useDispatch();
  const [emptyFieldInputError, setEmptyFieldInputError] = useState(false);
  const [extrasCursosData, setExtrasCursosData] = useState([]);
  const extrasRef = {
    CMinputRefs: useRef([]),
    EEinputRefs: useRef([]),
    ECinputRefs: useRef([{}, {}, {}, {}]),
  };

  const selectedCourses = useSelector((state) => state.data.extras);
  const persons_number = useSelector((state) => state.data.practicas.personas);
  const inputListCM = useSelector((state) => state.data.extrasInputListCM);
  const inputListEE = useSelector((state) => state.data.extrasInputListEE);
  const inputListEC = useSelector((state) => state.data.extrasInputListEC);
  const totalEnvios = inputListEC.length;

  // Feature Flags
  const isMedicCertificateEnabled = useSelector(
    (state) => state.featureFlag.extras.medicCertificate
  );
  const isExpressDeliveryEnabled = useSelector(
    (state) => state.featureFlag.extras.expressDelivery
  );
  const isOrdinaryMailDeliveryEnabled = useSelector(
    (state) => state.featureFlag.extras.ordinaryMailDelivery
  );

  useEffect(() => {
    setExtrasCursosData(selectedCourses);
  }, []);

  const handleBackExtrasScreen = () => {
    dispatch(dataActions.applyExtras([]));
    dispatch(dataActions.setResetExtrasState());
    dispatch(screenActions.setMainScreen("teoria"));
    dispatch(stepperActions.handleBackStep());
  };

  const handleNextScreen = () => {
    if (isFormCompleted(extrasRef, totalEnvios)) {
      //! Dispatch CM info
      const CMInputs = extrasRef.CMinputRefs.current.filter(
        (input) => input !== null
      );
      const CMValues = Object.values(CMInputs).map((input) => input.value);
      if (CMValues.length > 0) {
        dispatch(dataActions.setExtrasInputListCM(CMValues));
      }

      //! Dispatch EE info
      const EEInputs = extrasRef.EEinputRefs.current.filter(
        (input) => input !== null
      );
      const EEValues = Object.values(EEInputs).map((input) => input.value);
      if (EEValues.length > 0) {
        dispatch(dataActions.setExtrasInputListEE(EEValues));
      }

      //! Dispatch EC info
      const ECInputs = extrasRef.ECinputRefs.current.filter(
        (input) => Object.keys(input).length !== 0
      );

      const ECValues = ECInputs.slice(0, totalEnvios).map((refObject) => {
        const values = Object.values(refObject)
          .filter((input) => input !== null)
          .map((input) => input.value);
        return values;
      });

      let ECData = [];
      ECValues.forEach((values) => {
        const contactData = {
          nombre: values[0],
          direccion: values[1],
          poblacion: values[2],
          codigoPostal: values[3],
          telefono: values[4],
        };
        const certificatesList = values.slice(5, values.length);
        ECData.push({ contactData, certificatesList });
      });
      dispatch(dataActions.setExtrasInputListEC(ECData));
      dispatch(dataActions.applyExtras(extrasCursosData));
      dispatch(screenActions.setMainScreen("resumen"));
      dispatch(stepperActions.setActiveStep(3));
    } else {
      setEmptyFieldInputError(true);
    }
  };

  const handleIncluir = (checked, curso) => {
    let cursos;
    if (checked) {
      cursos = [...extrasCursosData, curso];
    } else {
      cursos = extrasCursosData.filter((element) => element.id !== curso.id);
    }
    setExtrasCursosData(cursos);
  };

  const updateCourseQuantity = (curso) => {
    const cursos = extrasCursosData.map((p) =>
      p.id == curso.id ? { ...p, courseQuantity: curso.courseQuantity } : p
    );
    setExtrasCursosData(cursos);
  };

  return (
    <>
      <Stepper />
      <motion.div
        className="extras__container"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
        exit="exit"
      >
        {/* Certificado Medico */}
        {isMedicCertificateEnabled && (
          <Curso
            id="CM"
            title={t("EXTRAS.cursos.CM")}
            price="39"
            checked={extrasCursosData.some((p) => p.id === "CM")}
            quantity={inputListCM.length}
            handleIncluir={handleIncluir}
            updateCourseQuantity={updateCourseQuantity}
            ref={extrasRef.CMinputRefs}
          />
        )}
        {/* Expedicion Express */}
        {isExpressDeliveryEnabled && (
          <Curso
            id="EE"
            title={t("EXTRAS.cursos.EE")}
            price="25"
            checked={extrasCursosData.some((p) => p.id === "EE")}
            quantity={inputListEE.length}
            handleIncluir={handleIncluir}
            updateCourseQuantity={updateCourseQuantity}
            ref={extrasRef.EEinputRefs}
          />
        )}

        {/* Envio correo
        Solo es posible enviar a una dirección por cada 4 personas... */}
        {isOrdinaryMailDeliveryEnabled && (
          <Curso
            id="EC"
            title={t("EXTRAS.cursos.EC")}
            price="10"
            checked={extrasCursosData.some((p) => p.id === "EC")}
            quantity={
              extrasCursosData.find((p) => p.id === "EC")
                ? extrasCursosData.find((p) => p.id === "EC").courseQuantity
                : persons_number
            }
            handleIncluir={handleIncluir}
            updateCourseQuantity={updateCourseQuantity}
            ref={extrasRef.ECinputRefs}
          />
        )}
        {emptyFieldInputError && (
          <motion.div
            variants={containerVariants}
            initial="hidden"
            animate="visible"
            exit="exit"
            style={{ color: "red", textAlign: "left" }}
          >
            {t("EXTRAS.error")}
          </motion.div>
        )}

        <div className="element__bottom curso__bottom">
          <div className="element__buttonsContainer">
            <div className="element__volverContainer">
              <button onClick={handleBackExtrasScreen}>
                {t("ELEMENT.button.back")}
              </button>
            </div>

            <div className="element__continueContainer">
              <button onClick={handleNextScreen}>
                {t("ELEMENT.button.next")}
              </button>
            </div>
          </div>
        </div>

        <InfoExtras />
      </motion.div>
    </>
  );
};

export default Extras;
